import { jsx, jsxs, Fragment } from "react/jsx-runtime";
import { RequiredIndicator, RequiredIndicatorPlacement } from "@wix/ambassador-forms-v4-form/types";
import classNames from "classnames";
import { useTranslation } from "../../contexts/translation-context.js";
import { ImageAlignment, ImagePosition, ImageFit } from "../../types/image.js";
import { ImageComponentWUT } from "../image-choice-field/image-component-wut.js";
import { classes } from "./field-label-wut.st.css";
const DEFAULT_IMAGE_ASPECT_RATIO = 3 / 2;
const FieldLabelWUT = ({
  labelId,
  htmlFor,
  label,
  required = false,
  hideLabel = false,
  requiredIndicatorHidden = false,
  requiredIndicatorType = RequiredIndicator.ASTERISK,
  requiredIndicatorPlacement = RequiredIndicatorPlacement.AFTER_FIELD_TITLE,
  media,
  mediaSettings
}) => {
  const Tag = htmlFor ? "label" : "div";
  const { t } = useTranslation();
  const {
    imagePosition = ImagePosition.TOP,
    imageFit = ImageFit.COVER,
    imageAlignment = ImageAlignment.CENTER
  } = media ? mediaSettings ?? {} : {};
  const labelAfterRequiredIndicator = requiredIndicatorType === RequiredIndicator.ASTERISK && requiredIndicatorPlacement === RequiredIndicatorPlacement.BEFORE_FIELD_TITLE;
  const imageElement = media ? /* @__PURE__ */ jsx("div", { className: classes.imageContainer, children: /* @__PURE__ */ jsx(
    ImageComponentWUT,
    {
      image: media,
      alt: media.altText,
      aspectRatio: DEFAULT_IMAGE_ASPECT_RATIO,
      imageAlignment,
      imageResize: imageFit
    }
  ) }) : null;
  const labelElement = /* @__PURE__ */ jsxs(
    Tag,
    {
      id: labelId,
      htmlFor,
      className: classNames(classes.label, {
        [classes.labelWithImage]: media,
        [classes.hidden]: hideLabel
      }),
      children: [
        !labelAfterRequiredIndicator && label,
        required && !requiredIndicatorHidden && /* @__PURE__ */ jsxs(Fragment, { children: [
          requiredIndicatorType === RequiredIndicator.ASTERISK && /* @__PURE__ */ jsx(
            "span",
            {
              "aria-hidden": "true",
              className: labelAfterRequiredIndicator ? classes.indicatorBeforeLabel : classes.indicatorAfterLabel,
              children: "*"
            }
          ),
          requiredIndicatorType === RequiredIndicator.TEXT && /* @__PURE__ */ jsx("span", { "aria-hidden": "true", className: classes.indicatorAfterLabel, children: t("settings.required-indicator-text") })
        ] }),
        labelAfterRequiredIndicator && label
      ]
    }
  );
  if (!media) {
    return labelElement;
  }
  return /* @__PURE__ */ jsxs("div", { className: classes.labelWithImageContainer, children: [
    imagePosition === ImagePosition.TOP ? imageElement : null,
    labelElement,
    imagePosition === ImagePosition.BOTTOM ? imageElement : null
  ] });
};
export {
  FieldLabelWUT
};
//# sourceMappingURL=field-label-wut.js.map
